/*
  * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
  * SPDX-License-Identifier: MIT
  *
  * Licensed under the MIT License. See the LICENSE accompanying this file
  * for the specific language governing permissions and limitations under
  * the License.
*/

/*
 * Protected Pages with Authentication
 */

import React from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux';

import { Auth } from 'aws-amplify';

import { setLang, setAuth, setUser } from '../../redux/actions';

const mapStateToProps = (state) => {
	return {
		user: state.user,
	}
}

class ProtectedRoute extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isAuthenticated: true
		}
	}

	componentDidMount() {
		Auth.currentAuthenticatedUser()
			.then(() => {
				this.setState({ isAuthenticated: true });
				this.props.setAuth(true);

				Auth.currentUserInfo()
					.then((user) => {
						this.props.setUser(user);
						this.props.setLang(user.attributes.locale || "ja");
					})
					.catch(err => {
						console.log(err);

						this.setState({ isAuthenticated: false })
						this.props.setAuth(false);
						this.props.setUser(null);
					});
			})
			.catch(err => {
				if (err !== "not authenticated") console.log(err)

				this.setState({ isAuthenticated: false })
				this.props.setAuth(false);
				this.props.setUser(null);
			});
	}

	render() {
		const loginPath = '/';

		const redirectTo = this.props.path.replace(/^\//, '') || null;

		const Component = this.props.component;

		const qs = new URLSearchParams(window.location.search);
		const externalRedirectUri = qs.get('redirect_uri');
		const externalState = qs.get('state');
		const externalClientId = qs.get('client_id');

		let searchParams = `redirect=${redirectTo}`;
		if (externalRedirectUri) searchParams += `&redirect_uri=${encodeURIComponent(externalRedirectUri)}`;
		if (externalState) searchParams += `&state=${encodeURIComponent(externalState)}`;
		if (externalClientId) searchParams += `&client_id=${encodeURIComponent(externalClientId)}`;

		return !this.state.isAuthenticated
			? (<Redirect to={{ pathname: loginPath, search: searchParams }} push={true} />)
			: (<Component />)
	}
}

export default connect(mapStateToProps, { setAuth, setUser, setLang })(ProtectedRoute);
